import {
	Box,
	styled,
} from '@mui/material'

export const ErrorFallbackRoot = styled(Box)`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	gap: var(--base-spacing-4);
	padding: var(--base-spacing-4);
	text-align: center;
	background-color: var(--surface-color);
`

export const ErrorFallbackCode = styled(Box)`
	font-size: 40px;
	font-weight: 900;
	line-height: 1;
	background: linear-gradient(125deg, var(--error-color) 0%, var(--don-color) 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
	margin-bottom: 6px;
`
